// extracted by mini-css-extract-plugin
module.exports = {"stopwatch":"Stopwatch_stopwatch__2Kpux"};